/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import {
  Button, Select, MenuItem, IconButton,
  Stack, Pagination,
  Tooltip,
  TooltipProps,
  linearProgressClasses,
  tooltipClasses,
} from '@mui/material';
import { styled } from '@mui/system';

import Color from '@tool/color';

const LookButton = styled(Button)(() => ({
  height: '36px',
  padding: '0 10px',
  borderRadius: '5px',
  fontSize: '14px',
}));

const DSelect = styled(Select)(() => ({
  height: '30px',

  '.MuiSelect-select': {
    display: 'inline-flex',
    alignItems: 'center',
    height: '30px',
    padding: '0 0 0 10px',
    fontSize: '12px',
    fontWeight: 600,
    color: Color.primary,
  },
  'svg': {
    width: '24px',
    height: '24px',
  },
  'fieldset': {
    display: 'none',
  },
}));

const DMenuItem = styled(MenuItem)(() => ({
  fontSize: '12px',
}));

const DIconButton = styled(IconButton)(() => ({
  width: '30px',
  height: '30px',
  padding: 0,
  borderRadius: '5px',
  border: `1px solid ${Color.ec}`,
}));

const DStack = styled(Stack)(() => ({
  justifyContent: 'center',
  margin: '10px 20px 35px 20px',

  'nav': {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow={true}
    classes={{ popper: className }}
    placement="top"/>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    '& p i': {
      fontSize: '14px',
      fontWeight: 500,
      color: Color.fff,
    },
    '& p span': {
      fontSize: '12px',
      lineHeight: 1,
      color: 'rgba(255, 255, 255, 0.5)',
    },
    '& p b': {
      fontSize: '14px',
      fontWeight: 600,
      marginLeft: '14px',
      color: '#F8AB42',
    },
    '& p.line-0110': {
      display: 'flex',
      justifyContent: 'center',
      margin: '10px 10px 0 10px',
    },
    '& p.line-0111': {
      display: 'flex',
      justifyContent: 'center',
      margin: '0 10px 10px 10px',
    },
    '& p.line-0113': {
      display: 'flex',
      justifyContent: 'center',
      margin: '10px',
    },
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
}));

export {
  HtmlTooltip, DMenuItem, DIconButton, DStack,
  DSelect, LookButton,
};
